import React from "react";
import Button from "../../components/UI/Button/Button";
import EmployeeRow from "./EmployeeRow";
import EmployeeAddForm from "./EmployeeAddForm";
import EmployeeEditForm from "./EmployeeEditForm";
import EmployeeDuplicateForm from "./EmployeeDuplicateForm";
import EmployeeDeleteForm from "./EmployeeDeleteForm";
import styles from "./EmployeeList.module.scss";

const EmployeeTable = ({ employees, openModal, closeModal, setEmployees }) => {
  const openAddModal = () => {
    const content = (
      <EmployeeAddForm onCancel={closeModal} setEmployees={setEmployees} />
    );
    openModal("Add Employee", content);
  };

  const openEditModal = (employee) => {
    const content = (
      <EmployeeEditForm
        employee={employee}
        onCancel={closeModal}
        setEmployees={setEmployees}
      />
    );
    openModal("Edit Employee", content);
  };

  const openDuplicateModal = (employee) => {
    const content = (
      <EmployeeDuplicateForm
        employee={employee}
        onCancel={closeModal}
        setEmployees={setEmployees}
      />
    );
    openModal("Add Duplicated Employee", content);
  };

  const openDeleteModal = (employee) => {
    const content = (
      <EmployeeDeleteForm
        employeeName={employee.name}
        employeeId={employee._id}
        onCancel={closeModal}
        setEmployees={setEmployees}
      />
    );
    openModal("Delete Employee", content);
  };

  return (
    <>
      <div className={styles.row}>
        <div className={styles.addButtonwrapper}>
          <Button onClick={openAddModal}>Add Employee</Button>
        </div>
      </div>
      <div className={styles.titleCard}>
        <div className={styles.cardInfo}>Name</div>
        <div className={styles.cardInfo}>Code</div>
        <div className={styles.cardInfo}>Department</div>
      </div>
      <div className={styles.contentWrapper}>
        {employees.map((employee, index) => (
          <EmployeeRow
            key={index}
            employee={employee}
            onEdit={openEditModal}
            onDuplicate={openDuplicateModal}
            onDelete={openDeleteModal}
          />
        ))}
      </div>
    </>
  );
};

export default EmployeeTable;
